import './video-intro.scss';
require('../../images/video-scroll/vignette.png');

class VideoIntro {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-videointro',
            mediaAttr: 'media',
            replayAttr: 'replay',
            soundAttr: 'sound',
            playAttr: 'play',
            pauseAttr: 'pause'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$videoIntro = element;
        this.$videoIntroMedia = this.$videoIntro.querySelector('[' + this.settings.initAttr + '="' + this.settings.mediaAttr + '"]');
        this.$videoIntroPlayButton = this.$videoIntro.querySelector('[' + this.settings.initAttr + '="' + this.settings.playAttr + '"]');
        this.$videoIntroPauseButton = this.$videoIntro.querySelector('[' + this.settings.initAttr + '="' + this.settings.pauseAttr + '"]');
        this.$videoIntroReplayButton = this.$videoIntro.querySelector('[' + this.settings.initAttr + '="' + this.settings.replayAttr + '"]');
        this.$videoIntroSoundButton = this.$videoIntro.querySelector('[' + this.settings.initAttr + '="' + this.settings.soundAttr + '"]');
        this.videoPlaying = false;
        this.muted = true;
        window.hasVideo = true;

        if (this.$videoIntroMedia === null) {
            console.error('no element found with ' + this.settings.initAttr + '="' + this.settings.mediaAttr + '"');
        }
    }

    _showButton ($btn) {
        if (!$btn) return;
        $btn.classList.remove('is--hidden');
        $btn.setAttribute('aria-hidden', 'false');
        $btn.setAttribute('tabindex', '0');
    }

    _hideButton ($btn) {
        if (!$btn) return;
        $btn.classList.add('is--hidden');
        $btn.setAttribute('aria-hidden', 'true');
        $btn.setAttribute('tabindex', '-1');
    }

    _addKeyboardSupport ($btn, handler) {
        if (!$btn) return;
        $btn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handler();
            }
        });
    }

    initialize () {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (reducedMotion) {
            this._hideButton(this.$videoIntroPauseButton);
            this._showButton(this.$videoIntroPlayButton);
            this.setEvents();
            return;
        }

        const playPromise = this.$videoIntroMedia.play();

        if (playPromise !== undefined) {
            playPromise.then(() => {
                this.$videoIntroMedia.pause();

                if (this.$videoIntroMedia.getAttribute('data-moodvideo') === null) {
                    if (this.$videoIntroMedia.readyState > 3) {
                        this.$videoIntroMedia.play();
                    } else {
                        this.$videoIntroMedia.addEventListener('canplaythrough', () => {
                            this.$videoIntroMedia.play();
                        });
                    }
                }

                this.setEvents();
            })
                .catch();
        }
    }

    setEvents () {
        this.$videoIntroMedia.addEventListener('ended', () => {
            this.$videoIntro.classList.add('is--media-ended');
            this.$videoIntroMedia.setAttribute('playing', false);
            this.videoPlaying = false;
            this._hideButton(this.$videoIntroPlayButton);
            this._hideButton(this.$videoIntroPauseButton);
            this._showButton(this.$videoIntroReplayButton);
            window.dispatchEvent(new Event('video-intro-ended'));
        });

        this.$videoIntroMedia.addEventListener('pause', () => {
            this.$videoIntro.classList.add('is--media-ended');
            this.$videoIntroMedia.setAttribute('playing', false);
            this.videoPlaying = false;

            if (!this.$videoIntroMedia.ended) {
                this._showButton(this.$videoIntroPlayButton);
                this._hideButton(this.$videoIntroPauseButton);
            }

            if (this.$videoIntroMedia.muted === false && this.$videoIntroSoundButton !== null) {
                this.$videoIntroMedia.muted = true;
                this.$videoIntroSoundButton.classList.remove('has--volume');
                this.$videoIntroSoundButton.setAttribute('aria-pressed', 'false');
            }

            window.dispatchEvent(new Event('video-intro-paused'));
        });

        this.$videoIntroMedia.addEventListener('play', () => {
            this.$videoIntro.classList.remove('is--media-ended');
            this.$videoIntroMedia.setAttribute('playing', true);
            this.videoPlaying = true;
            this._hideButton(this.$videoIntroPlayButton);
            this._showButton(this.$videoIntroPauseButton);
            this._hideButton(this.$videoIntroReplayButton);
        });

        if (this.$videoIntroPlayButton !== null) {
            const playHandler = () => { this.$videoIntroMedia.play(); };
            this.$videoIntroPlayButton.addEventListener('click', playHandler);
            this._addKeyboardSupport(this.$videoIntroPlayButton, playHandler);
        }

        if (this.$videoIntroPauseButton !== null) {
            const pauseHandler = () => { this.$videoIntroMedia.pause(); };
            this.$videoIntroPauseButton.addEventListener('click', pauseHandler);
            this._addKeyboardSupport(this.$videoIntroPauseButton, pauseHandler);
        }

        if (this.$videoIntroReplayButton !== null) {
            const replayHandler = () => {
                this.$videoIntroMedia.play();
                window.dispatchEvent(new Event('video-intro-restart'));
            };
            this.$videoIntroReplayButton.addEventListener('click', replayHandler);
            this._addKeyboardSupport(this.$videoIntroReplayButton, replayHandler);
        }

        if (this.$videoIntroSoundButton !== null) {
            const soundHandler = () => {
                if (this.$videoIntroMedia.muted === true) {
                    this.$videoIntroMedia.muted = false;
                    this.$videoIntroSoundButton.classList.add('has--volume');
                    this.$videoIntroSoundButton.setAttribute('aria-pressed', 'true');
                } else {
                    this.$videoIntroMedia.muted = true;
                    this.$videoIntroSoundButton.classList.remove('has--volume');
                    this.$videoIntroSoundButton.setAttribute('aria-pressed', 'false');
                }
            };
            this.$videoIntroSoundButton.addEventListener('click', soundHandler);
            this._addKeyboardSupport(this.$videoIntroSoundButton, soundHandler);
        }
    }
}

export { VideoIntro };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $videoIntros = $context.querySelectorAll('[data-videointro="root"]');

        if ($videoIntros.length > 0) {
            for (let i = 0; i < $videoIntros.length; i++) {
                const $videoIntro = new VideoIntro($videoIntros[i]);
                $videoIntro.initialize();
            }
        }
    }
});
